import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import InfoSection from "../components/InfoSection";
import ServicesSection from "../components/ServiceSection";
import {
  homeObjOne,
  homeObjTwo,
  homeObjThree,
} from "../components/InfoSection/Data";
import SignUp from "../components/SignUp";
// import Projects from "../components/Projects/Projects";
import "react-toastify/dist/ReactToastify.css";
import Certified from "../components/Certified/Certified";
import Proyectos from "../components/Proyectos/Proyectos";

const Aboutpage = () => {
  const [isOpen, setIsopen] = useState(false);

  const toogle = () => {
    setIsopen(!isOpen);
  };

  const [currentLanguage, setCurrentLanguage] = useState("es");

  const handleLanguageChange = (newLanguage) => {
    setCurrentLanguage(newLanguage);
  };

  return (
    <>
      <Sidebar isOpen={isOpen} toogle={toogle} />
      <Navbar
        toogle={toogle}
        isOpen={isOpen}
        currentLanguage={currentLanguage}
        onChangeLanguage={handleLanguageChange}
      />
      <InfoSection {...homeObjTwo} />
      <Proyectos />
      <InfoSection {...homeObjThree} />
      <InfoSection {...homeObjOne} />
      <Certified />
      {/* <Projects /> */}
      <ServicesSection />
      <SignUp />
    </>
  );
};

export default Aboutpage;
